module.exports = __webpack_public_path__ + "img/background-lobby-mobile.c98a076b.jpg";